import * as React from 'react';
import { EMPTY_TEXT } from '@mitchell/react.component.ux';
import { CountryCode, EnterpriseDocStoreService, TranslationService } from "../../../common";
import { IntelligentAssignmentSummary, IntelligentPhotoCapturePhotoPreviewConstants, OCR_previewScreen_RegEx_validator, PhotoCaptureConstants } from '../../constants';
import { IntelligentPhotoCaptureEstimatorContentType, IntelligentPhotoCaptureViewType } from '../../enums';
import { attachmentInfo, getEstimatorSummaryHeaderText } from '../../utilities';
import { StyledEditWrapper } from './IntelligentAssignmentSummaryComponent.style';
import { StyledPreviewInput } from './IntelligentPhotoCapturePhotoPreviewPage.style';
import { IntelligentPhotoCaptureImageSection } from './IntelligentPhotoCaptureImageSection';
import { IntelligentPBEContainerComponent } from './IntelligentPBEContainerComponent';
export const IntelligentAssignmentSummaryEditHandlerComponent = ({ appTheme, companyCode, contentType, contextId, countryCode, photoCaptureAttachmentInfo, selectedAttachmentId, userVehicleInfo, vehicle, onSetOCRUserVerified, onUploadAttachments, onViewChange }) => {
    const translateFn = TranslationService.translate;
    const selectedAttachment = selectedAttachmentId !== undefined && selectedAttachmentId !== null
        ? attachmentInfo.getAttachmentBySelectedTileId(photoCaptureAttachmentInfo, selectedAttachmentId)
        : undefined;
    const ocrText = attachmentInfo.getAttachmentTextByContentType(selectedAttachment, contentType);
    const imageSrc = React.useMemo(() => EnterpriseDocStoreService.createFileUrl((selectedAttachment === null || selectedAttachment === void 0 ? void 0 : selectedAttachment.fileId) || EMPTY_TEXT), [selectedAttachment]);
    const [inputValue, setInputValue] = React.useState(ocrText);
    const [warningMessage, setWarningMessage] = React.useState(EMPTY_TEXT);
    const getWarningMessage = () => {
        if (contentType !== IntelligentPhotoCaptureEstimatorContentType.ODOMETER) {
            return EMPTY_TEXT;
        }
        const regex = countryCode === CountryCode.UNITED_STATES
            ? OCR_previewScreen_RegEx_validator.MILEAGE_CAPTURE_REGEX_US
            : OCR_previewScreen_RegEx_validator.MILEAGE_CAPTURE_REGEX_CA;
        return regex.test(inputValue)
            ? EMPTY_TEXT
            : IntelligentPhotoCapturePhotoPreviewConstants.MILEAGE_CAPTURE_WARNING_MESSAGE;
    };
    const handleEditInputChange = React.useCallback((event) => {
        setInputValue(event.target.value);
    }, []);
    const handleSaveEdit = React.useCallback(() => {
        const updatedAttachmentInfo = attachmentInfo.updateAttachmentOCRDetailsById(selectedAttachment, contentType, inputValue !== ocrText ? inputValue : ocrText);
        if (updatedAttachmentInfo) {
            onUploadAttachments([[updatedAttachmentInfo]], contextId, companyCode);
            onSetOCRUserVerified(contentType);
        }
        onViewChange(IntelligentPhotoCaptureViewType.NONE);
    }, [
        companyCode,
        contentType,
        contextId,
        inputValue,
        ocrText,
        onSetOCRUserVerified,
        onViewChange,
        onUploadAttachments,
        selectedAttachment
    ]);
    const getInputMaxLengthBased = React.useCallback((estimatorContentType) => {
        if (estimatorContentType === IntelligentPhotoCaptureEstimatorContentType.ODOMETER) {
            return PhotoCaptureConstants.MILEAGE_LENGTH;
        }
        else {
            return PhotoCaptureConstants.LICENSE_LENGTH;
        }
    }, []);
    React.useEffect(() => {
        setWarningMessage(translateFn(getWarningMessage()));
    }, [inputValue, countryCode, contentType]);
    return (React.createElement(IntelligentPBEContainerComponent, { islanguageHide: true, appTheme: appTheme, isFooter: true, hasMultipleButton: false, btnLabel: TranslationService.translate(IntelligentAssignmentSummary.DONE_BUTTON_LABEL), moveNext: handleSaveEdit, movePrevious: () => onViewChange(IntelligentPhotoCaptureViewType.NONE), estimatorSummaryHeaderText: getEstimatorSummaryHeaderText(userVehicleInfo !== null && userVehicleInfo !== void 0 ? userVehicleInfo : vehicle), shouldShowAvatar: false, warningMessage: warningMessage, isBtnDisabled: !!warningMessage || !inputValue.trim() },
        React.createElement(StyledEditWrapper, null,
            React.createElement(IntelligentPhotoCaptureImageSection, { imageSrc: imageSrc }),
            React.createElement(StyledPreviewInput, { value: inputValue, onChange: handleEditInputChange, minLength: 0, maxLength: getInputMaxLengthBased(contentType) }))));
};
//# sourceMappingURL=IntelligentAssignmentSummaryEditHandlerComponent.js.map